export enum RoutePath {
    SIGN_IN = '/',
    CUSTOMER_PORTAL = '/portal',
    ADMIN_SIGN_IN = '/admin',
    ADMIN_PORTAL = '/admin/portal',
    EXCLUSIVE = '/exclusive'
}

export enum RouteRestriction {
    ADMIN_ONLY,
    CUSTOMER_ONLY
}

export enum AuthState {
    NONE,
    CUSTOMER,
    ADMIN
}